'use client';

import { c as _c } from "react/compiler-runtime";
import { Body, Button, H5 } from '@material-bank/mb3-components';
import { useTranslations } from '@material-bank/i18n';
import { useCreateAccount } from '../../../hooks/useCreateAccount';
import type { DialogOptionsBenefit } from '../../../providers/AuthenticationDialogProvider';
type BenefitsStepProps = {
  title: string;
  description?: string;
  benefits: DialogOptionsBenefit[];
  onSignIn: () => void;
  onDismiss: () => void;
};
export function BenefitsStep(t0) {
  const $ = _c(37);
  const {
    title,
    description,
    benefits,
    onSignIn,
    onDismiss
  } = t0;
  const t = useTranslations("authentication.loginPrompt");
  const {
    isCreateAccountDisabled,
    createAccountClickHandler
  } = useCreateAccount();
  let t1;
  if ($[0] !== title) {
    t1 = <H5 weight="semibold" className="text-foreground text-balance">{title}</H5>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description ? <Body className="text-muted-foreground text-pretty">{description}</Body> : null;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col gap-1">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== benefits) {
    t4 = benefits.map(_temp);
    $[7] = benefits;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <ul className="flex flex-col gap-4">{t4}</ul>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("createAccount");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== createAccountClickHandler || $[14] !== isCreateAccountDisabled || $[15] !== t6) {
    t7 = <Button variant="secondary" size="xl" className="w-full rounded-full h-12 px-4" onClick={createAccountClickHandler} disabled={isCreateAccountDisabled} data-haptic="light">{t6}</Button>;
    $[13] = createAccountClickHandler;
    $[14] = isCreateAccountDisabled;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("logIn");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== onSignIn || $[20] !== t8) {
    t9 = <Button variant="brand" size="xl" className="w-full rounded-full h-12 px-4" onClick={onSignIn} data-haptic="light" data-analyticsid="popup_modal_sign_in_sign_in_modal">{t8}</Button>;
    $[19] = onSignIn;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t7 || $[23] !== t9) {
    t10 = <div className="grid grid-cols-2 gap-2">{t7}{t9}</div>;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t("dismiss");
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== onDismiss || $[28] !== t11) {
    t12 = <Button variant="ghost" size="xl" className="w-full rounded-full h-12" onClick={onDismiss} data-haptic="light">{t11}</Button>;
    $[27] = onDismiss;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t10 || $[31] !== t12) {
    t13 = <div className="flex flex-col gap-2">{t10}{t12}</div>;
    $[30] = t10;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t13 || $[34] !== t3 || $[35] !== t5) {
    t14 = <div className="flex flex-col gap-6 px-6 pt-1 pb-4">{t3}{t5}{t13}</div>;
    $[33] = t13;
    $[34] = t3;
    $[35] = t5;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
}
function _temp(benefit) {
  return <li key={benefit.title} className="flex items-center gap-3.5"><span className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-white text-foreground shadow-xs ring-1 ring-border">{benefit.icon}</span><div className="flex flex-col min-w-0"><Body weight="semibold" className="text-foreground">{benefit.title}</Body><Body variant="small" className="text-muted-foreground text-pretty">{benefit.description}</Body></div></li>;
}